import { cover } from "polished";
import styled, { css } from "styled-components";
import Link from "../../quarks/Link";
import { cssTextAtm } from "../TextAtm/TextAtm.styled";

// eslint-disable-next-line import/prefer-default-export
export var StyledUnderlineLinkAtm = styled(Link).withConfig({
  componentId: "sc-1i0qzod-0"
})(function (_ref) {
  var $typography = _ref.$typography,
    $color = _ref.$color,
    $emphasis = _ref.$emphasis,
    $hasCover = _ref.$hasCover,
    $onColor = _ref.$onColor;
  return css(["", ";cursor:pointer;text-decoration:underline;", ";&:hover{text-decoration:none;}"], cssTextAtm({
    typography: $typography,
    onColor: $onColor,
    color: $color,
    emphasis: $emphasis
  }), $hasCover && css(["&::after{", ";content:\"\";}"], cover()));
});